<template>
  <div class="item__list">
    <article class="item" v-for="(item, i) in potlist" :key="i">
      <div class="item__box box" :class="{archived: item.status === 2}">
        <div class="icon"><img src="/imgs/icon-orange.png" width="48px" height="48px" alt="pot thumb" /></div>
        <div class="detail">
          <p class="author fx_ctr">
            <router-link v-if="item.author !== null" :to="'/explore/users/testsu-tabata/'">{{item.author}}</router-link>
            <span class="name" v-else>Anonymously</span>
            <span class="date">{{fDate(item.updated_at)}}</span>
          </p>
          <h2 class="title"><router-link :to="'/pots/' + item.id" @click.native="toggleSpSlide()">{{item.title}}</router-link></h2>
        </div>
        <button class="lock" aria-label="unlock a pot"><font-awesome-icon icon="lock" /></button>
      </div>
    </article>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    data() {
      return {
        potlist:[]
      }
    },
    props: ['status'],
    computed: {
      ...mapGetters([
        "isPotsLoaded", "isPotsLoading", "getPotsCount"
      ])
    },
    created(){
      this.getList()
    },
    watch: {
      '$route' () {
        this.getList()
      }
    },
    methods: {
      ...mapActions([
        "toggleSpSlide", "getPots", "potsSelect"
      ]),
      getList: async function(){
        this.potlist = await this.$db.pots.orderBy('updated_at').desc().toArray()
        .then(async (data)=>{
          // status 0の修正
          // for(let d in data){
          //   console.log(data[d].status);
          //   if(data[d].status === 0){
          //     await this.$db.pots.update(data[d].id, {status: 1});
          //   }
          // }
          if(status !== undefined){
            return data.filter(result => result.status === this.status);
          }else{
            return data
          }
        })
      },
    },
  }
</script>

<style lang="scss">
.item__list{
  border-radius: 3px;
  .item{
    border-bottom: 1px solid #DDD;
    &:last-child{
      border-bottom: 0;
    }
    .item__box{
      display: flex;
      padding-right: 48px;
      position: relative;
      transition: background .5s ease 0s;
      background: #FFF;
      &.archived{
        &:hover{
          background: #CCC;
        }
        background: #AAA;
        color: #999;
        .detail{
          .title{
            a{
              color: #999;
            }
          }
        }
        .icon{
          opacity: .3;
        }
      }
      &:hover{
        background: #FAFAFA;
      }
      .detail{
        .author{
          font-size: .8rem;
          margin-bottom: 4px;
          a{
            font-weight: bold;
            color: #666;
            text-decoration: none;
            margin-right: 16px;
          }
          .name{
            font-weight: bold;
            margin-right: 16px;
            display: inline-block;
          }
        }
        .title{
          font-size: .9rem;
          line-height: 1.2rem;
          a{
            display: block;
            color: #0b7a29;
            text-decoration: none;
            padding: 4px 0;
          }
        }
      }
      .lock{
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        font-size: .9rem;
        color: #AAA;
        width: 48px;
      }
    }
  }
}

</style>
